'use client';

import { __assign, __awaiter, __generator } from '../../_virtual/_tslib.js';
import React__default, { memo, useState, useEffect } from 'react';
import { Container } from './styled.js';
import { SCRIPT_TIKTOK_EMBED_ID, CDN_TIKTOK_EMBED } from './const.js';
import { EStatusTikTokEmbed } from './type.js';
import { getTikTokEmbed } from '../../services/social-embed/index.js';
import ModelError from '../../services/model/index.js';

function TikTok(_a) {
    var _this = this;
    var blockStyle = _a.blockStyle, baseMsUrl = _a.baseMsUrl, langCode = _a.langCode, groupJobFunctions = _a.groupJobFunctions;
    var _b = useState(EStatusTikTokEmbed.PROCESSING), status = _b[0], setStatus = _b[1];
    var _c = useState(), source = _c[0], setSource = _c[1];
    var getSourceTikTok = function () { return __awaiter(_this, void 0, void 0, function () {
        var tikTokEmbed, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getTikTokEmbed(baseMsUrl, langCode, groupJobFunctions)];
                case 1:
                    tikTokEmbed = _a.sent();
                    if (tikTokEmbed instanceof ModelError) {
                        return [2 /*return*/];
                    }
                    setSource(tikTokEmbed.source);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (status === EStatusTikTokEmbed.PROCESSING) {
            var prevScript = document.querySelector(SCRIPT_TIKTOK_EMBED_ID);
            if (prevScript) {
                prevScript.remove();
            }
            var scriptElement = document.createElement('script');
            scriptElement.setAttribute('src', "".concat(CDN_TIKTOK_EMBED, "?t=").concat(Date.now()));
            scriptElement.setAttribute('id', SCRIPT_TIKTOK_EMBED_ID);
            document.head.appendChild(scriptElement);
            setStatus(EStatusTikTokEmbed.SUCCESS);
        }
        else if (status === EStatusTikTokEmbed.SUCCESS) {
            getSourceTikTok();
        }
    }, [status, groupJobFunctions]);
    return source ? React__default.createElement(Container, __assign({}, blockStyle, { dangerouslySetInnerHTML: { __html: source } })) : React__default.createElement(React__default.Fragment, null);
}
var index = memo(TikTok, function (prevProps, nextProps) {
    if (prevProps.groupJobFunctions !== nextProps.groupJobFunctions) {
        return true;
    }
    return false;
});

export { index as default };
//# sourceMappingURL=index.js.map
